import { V2PeriodDetailPostResponse } from '@maxtropy/device-customer-apis-v2';

export const ColorList = ['#ABD335', '#52E7FF', '#FF9247', '#16DD8E', '#CE90D1', '#FF477B', '#2D8DFF'];

export const format = 'HH:mm';

export const weekOptions = [
  {
    value: 1,
    label: '周一',
  },
  {
    value: 2,
    label: '周二',
  },
  {
    value: 3,
    label: '周三',
  },
  {
    value: 4,
    label: '周四',
  },
  {
    value: 5,
    label: '周五',
  },
  {
    value: 6,
    label: '周六',
  },
  {
    value: 7,
    label: '周日',
  },
];

export enum TimeType {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export type DatePeriodItem = {
  id?: number;
  startTime?: string;
  endTime?: string;
};

export type DayPeriodItem = Exclude<V2PeriodDetailPostResponse['list'], undefined>[number];
